import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container, Grid, Typography } from 'components/base';

import { THEMES } from './homeCarousel';

import CarouselBgLeft from '../../../public/static/img/carousel-item-bg-left.svg';
import CarouselBgRight from '../../../public/static/img/carousel-item-bg-right.svg';

const HeroBanner = forwardRef((props, ref) => {
  const theme = THEMES[1];

  const className = classNames({
    carousel: true,
    'hero-banner': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} style={{ backgroundColor: theme.backgroundColor }}>
      <Container>
        <Grid.Row>
          <Grid.Col xs={12} md={6} className="hero-banner-bg">
            <div className="hero-banner-data">
              <Typography.H1>{props.title}</Typography.H1>
              <Typography.P>{props.description}</Typography.P>
            </div>
            <span className="hero-banner-bg-left" style={{ color: theme.color }}>
              <CarouselBgLeft />
            </span>
            <span className="hero-banner-bg-right" style={{ color: theme.color }}>
              <CarouselBgRight />
            </span>
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            {props.children}
          </Grid.Col>
        </Grid.Row>
      </Container>
    </div>
  );
});

HeroBanner.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default HeroBanner;
